// extracted by mini-css-extract-plugin
export default {"service_card":"style_service_card__Ighvc"};